export enum Namespaces {
    operating = "operating",
    entrust = "entrust",
    promote = "promote",
    economics = "economics"
}
